var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box is-centered wrapper-data-receiver" }, [
    _c(
      "h1",
      { staticClass: "title is-4 has-text-primary title-data-receiver" },
      [_vm._v("\n    Datos de Receptor\n  ")]
    ),
    _c(
      "div",
      { staticClass: "columns is-multiline" },
      [
        !_vm.isTradeTransfer
          ? _c(
              "div",
              {
                staticClass: "column",
                class: { "is-6": !_vm.inline, "is-4": _vm.inline }
              },
              [
                _c("CustomerSearcherByRFC", {
                  attrs: {
                    disabled: _vm.isLoading || _vm.disabled,
                    required: ""
                  },
                  on: {
                    select: function($event) {
                      return _vm.$emit("customer", $event)
                    }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          {
            staticClass: "column",
            class: {
              "is-6": !_vm.inline,
              "is-4": _vm.inline,
              "is-12": _vm.isTradeTransfer
            }
          },
          [
            _c("CustomerSearcherByTradeName", {
              attrs: { disabled: _vm.isLoading || _vm.disabled, required: "" },
              on: {
                select: function($event) {
                  return _vm.$emit("customer", $event)
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "column",
            class: { "is-6": !_vm.inline, "is-4": _vm.inline }
          },
          [
            _c("CustomerSearcherByEmail", {
              attrs: {
                disabled: _vm.isLoading || _vm.disabled,
                value: _vm.$store.state.customers.email,
                required: ""
              },
              on: {
                select: function($event) {
                  return _vm.$emit("customer", $event)
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "column",
            class: { "is-6": !_vm.inline, "is-4": _vm.inline }
          },
          [
            _c("CustomerSearcherByName", {
              attrs: {
                disabled: _vm.isLoading || _vm.disabled,
                value: _vm.$store.state.customers.name,
                required: ""
              },
              on: {
                select: function($event) {
                  return _vm.$emit("customer", $event)
                }
              }
            })
          ],
          1
        ),
        !_vm.isTradeTransfer
          ? _c("div", { staticClass: "column is-12 is-centered" }, [
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [
                  _vm._v("\n          ¿Eres extranjero?\n        ")
                ]),
                _c("div", { staticClass: "control is-flex is-centered" }, [
                  _c("div", { staticClass: "field has-addons" }, [
                    _c("p", { staticClass: "control" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button",
                          class: {
                            "is-success": _vm.isForeign,
                            "is-loading": _vm.isLoading
                          },
                          attrs: { disabled: _vm.disabled },
                          on: {
                            click: function($event) {
                              return _vm.onChangeForeign(true)
                            }
                          }
                        },
                        [_c("span", [_vm._v("Sí")])]
                      )
                    ]),
                    _c("p", { staticClass: "control" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button",
                          class: {
                            "is-success": !_vm.isForeign,
                            "is-loading": _vm.isLoading
                          },
                          attrs: { disabled: _vm.disabled },
                          on: {
                            click: function($event) {
                              return _vm.onChangeForeign(false)
                            }
                          }
                        },
                        [_c("span", [_vm._v("No")])]
                      )
                    ])
                  ])
                ])
              ])
            ])
          : _vm._e(),
        _vm.isForeign
          ? [
              _c(
                "div",
                {
                  staticClass: "column",
                  class: { "is-12": !_vm.inline, "is-4": _vm.inline }
                },
                [
                  _c("AppInputField", {
                    attrs: {
                      id: "address",
                      name: "receiverFiscalResidence",
                      label: "Residencia fiscal",
                      placeholder: "Residencia fiscal",
                      value: _vm.receiverFiscalResidence,
                      disabled: _vm.disabled,
                      "is-loading": _vm.isLoading
                    },
                    on: { input: _vm.onChange, change: _vm.onChange }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "column",
                  class: { "is-12": !_vm.inline, "is-4": _vm.inline }
                },
                [
                  _c("AppInputField", {
                    attrs: {
                      id: "numRegIdTrib",
                      name: "receiverNumRegIdTrib",
                      label: "Número de registro identificación tributaria ",
                      placeholder:
                        "Número de registro identificación tributaria ",
                      value: _vm.receiverNumRegIdTrib,
                      disabled: _vm.disabled,
                      "is-loading": _vm.isLoading
                    },
                    on: { input: _vm.onChange, change: _vm.onChange }
                  })
                ],
                1
              )
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }